import Header from '../components/header'
import Footer from '../components/footer'
import Eachpart from "../components/eachpart";
import './about.css'
// [Script] => Import all imgs from assets From importingScript file
import { images } from '../components/importingScript';

const About = ({page}) => {
  return (
    <>
      <Header />
      <Eachpart pageName="About" />

      {/* About Section */}
      <div pageName="About" className="container-xxl about mb-5" style={{marginTop: '6rem'}}>
        <div className="container">
          <div className="row g-0">
            <div className="col-lg-6">
              <div className="h-100 d-flex align-items-center justify-content-center" style={{minHeight: '300px'}}>
                <button type="button" className="btn-play" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-bs-target="#videoModal">
                  <span />
                </button>
              </div>
            </div>
            <div className="col-lg-6 pt-lg-5 wow fadeIn" data-wow-delay="0.5s" style={{visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeIn'}}>
              <div className="bg-white rounded-top p-5 mt-lg-5">
                <p className="fs-5 fw-medium text-primary">About Us</p>
                <h1 className="display-6 mb-4">The Best Marketing Agency to Improve Your Business</h1>
                <p className="mb-4">


                 
 <br></br>
Founded in 2020 and headquartered in the thriving city of Nashik, Unique Digital Hub is a premier digital marketing agency dedicated to empowering businesses in the digital age. We bring together a team of seasoned experts with a deep understanding of the ever-evolving digital landscape to deliver measurable and impactful results.  
<br></br>

Our core expertise lies in: 
<br></br> 
<b>Social Media Marketing</b>: Crafting engaging campaigns to build meaningful connections and expand your reach.  
<br></br>

<b>SEO Strategy</b>: Driving organic growth through advanced search engine optimization techniques.  
<br></br>

<b>Website Design & Development</b>: Creating visually striking, user-friendly websites tailored to your brand identity.  
<br></br>

<b>Digital Advertising </b>: Designing high-performing ad campaigns that maximize your return on investment. 
<br></br>


At Unique Digital Hub, we pride ourselves on delivering tailored strategies that align with your business objectives. Whether you're a startup aiming to establish your presence or an established enterprise looking to scale, we are your trusted partner in achieving digital excellence. 
<br></br> 

Let’s transform your vision into reality—because your success is our mission.  
<br></br>


This version emphasizes professionalism and positions your company as a trusted and results-driven partner. Let me know if you’d like any further adjustments!</p>
          
            <div className="col-lg-6 pt-lg-5 wow fadeIn" data-wow-delay="0.5s" style={{visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeIn'}}>
            {/* <div className="bg-white rounded-top p-5 mt-lg-5">
                    <img className="img-fluid mb-4" src={images["./icon/icon-1.png"]}  alt="icon" />
                    <h5 className="mb-3">Managed Services</h5>
                    <span>

---

<b> Managed Services  </b>

At <b>Unique Digital Hub</b>, Our  Services are designed to provide end-to-end support for your digital marketing and online presence, allowing you to focus on your core business operations. Our team of experts takes the reins to ensure your digital strategies are always optimized, up-to-date, and driving measurable results.  
<br></br>
Our Services include:  
<br></br>
- <b>Social Media Management</b>:  
  Comprehensive account handling, content creation, scheduling, audience engagement, and analytics to grow your brand across platforms.  
  <br></br>
- <b>Website Maintenance</b>:  
  Continuous monitoring, updates, performance optimization, and security enhancements to ensure your website functions seamlessly.  
  <br></br>
- <b>SEO Management</b>: 
  Ongoing keyword research, content optimization, technical SEO, and link-building strategies to enhance search rankings and visibility.  
  <br></br>
- <b>Ad Campaign Management</b>:  
  End-to-end management of digital ad campaigns on platforms like Google Ads, Facebook, and Instagram to maximize ROI and reach.  
  <br></br>
- Analytics & Reporting:  
  Regular performance tracking and customized reports with actionable insights to ensure your campaigns are achieving the desired results.  
  <br></br>
At Unique Digital Hub, we combine expertise, cutting-edge tools, and a client-first approach to offer managed services that deliver sustained growth and success. Let us handle the complexities of your digital presence while you focus on your business goals.  
<br></br>

Let me know if you’d like to add more specifics or further refine it!</span>
                  </div>
               */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;